import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {UserService} from '../../core/services/user.service';
import {Router} from '@angular/router';
import {HttpService} from '../../core';
import {MatMenu} from '@angular/material/menu';
import {environment} from '../../../environments/environment';
import {NotificationService} from '../../core/services/notification.service';

declare var Intercom: any;

/**
 * @class LeftNavComponent
 * @memberOf ThemeModule
 * @description The component control the UI of left side navigation bar
 */
@Component({
  selector: 'app-left-nav',
  templateUrl: './left-nav.component.html',
  styleUrls: ['./left-nav.component.scss']
})

export class LeftNavComponent implements OnInit, AfterViewInit {
  @Input() user: any;
  @Output() private childOuter = new EventEmitter();
  @Output() private toggleLeftNav = new EventEmitter();

  @ViewChild('leftNav') private leftNav: ElementRef;
  @ViewChild('accountDropdown') private accountDropdown: MatMenu;
  @ViewChild('languageMenu') private languageMenu: MatMenu;

  email: string;
  highestRole: any;
  company: any;
  smallScreen = false;
  SERVER_URL = environment.SERVER_URL;

  constructor(public userService: UserService,
              private router: Router,
              // private languageService: LanguageService,
              // public translate: TranslateService,
              private httpService: HttpService,
              // private companyService: CompanyService,
              // public timeService: TimeService
              public notificationService: NotificationService
  ) {
  }

  ngOnInit(): void {
    // this.userService.currentUser.subscribe((r: any) => {
    //     this.user = r;
    //     this.highestRole = r.roles[0];
    //     this.email = r.email;
    //     this.companyService.id = this.user.company.id;
    //     this.companyService.company.subscribe(company => {
    //         this.company = company;
    //     });
    // });
    // 导航栏初始化时 获取数据;
    this.notificationService.getNotification('', 0, 25);
  }

  ngAfterViewInit(): void {
    const screenWidth = window.innerWidth;
    this.smallScreen = screenWidth < 1280
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/auth/login']);
    // this.userService.logOut().subscribe((res: any) => {
    //     if (res.code === 1) {
    //         this.router.navigate(['/auth/login']);
    //     } else {
    //         console.log('Logout Failure');
    //     }
    // });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const screenWidth = window.innerWidth;
    this.smallScreen = screenWidth < 1280;
  }

  openIntercom() {
    Intercom('showNewMessage');
  }
}
